import { z } from 'zod';
import { localeSchema, countryCodeSchema, currencyCodeSchema } from './common';

export const loginSchema = z.object({
  email: z.string().email().toLowerCase(),
  password: z.string().min(1),
  remember: z.boolean().optional().default(false),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    name: z.string().min(2).max(120),
    email: z.string().email().toLowerCase(),
    password: z.string().min(8).max(128),
    passwordConfirmation: z.string(),
    locale: localeSchema.optional(),
    timezone: z.string().optional(),
    countryCode: countryCodeSchema.optional(),
    baseCurrency: currencyCodeSchema.optional(),
  })
  .refine((d) => d.password === d.passwordConfirmation, {
    message: 'Parolalar uyuşmuyor',
    path: ['passwordConfirmation'],
  });
export type RegisterInput = z.infer<typeof registerSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().email().toLowerCase(),
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z
  .object({
    token: z.string().min(1),
    email: z.string().email().toLowerCase(),
    password: z.string().min(8).max(128),
    passwordConfirmation: z.string(),
  })
  .refine((d) => d.password === d.passwordConfirmation, {
    message: 'Parolalar uyuşmuyor',
    path: ['passwordConfirmation'],
  });
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const confirmPasswordSchema = z.object({
  password: z.string().min(1),
});
export type ConfirmPasswordInput = z.infer<typeof confirmPasswordSchema>;

export const twoFactorChallengeSchema = z
  .object({
    tempToken: z.string().min(1),
    code: z.string().min(6).max(8).optional(),
    recoveryCode: z.string().min(8).optional(),
  })
  .refine((d) => d.code || d.recoveryCode, {
    message: 'Kod veya kurtarma kodu gerekli',
    path: ['code'],
  });
export type TwoFactorChallengeInput = z.infer<typeof twoFactorChallengeSchema>;

export const enableTwoFactorSchema = z.object({
  code: z.string().length(6).regex(/^\d+$/, 'Sadece rakam'),
});
export type EnableTwoFactorInput = z.infer<typeof enableTwoFactorSchema>;

export const verifyEmailSchema = z.object({
  token: z.string().min(1),
});
export type VerifyEmailInput = z.infer<typeof verifyEmailSchema>;
